export default __webpack_public_path__ + "static/media/text-allign-center.46b09e38.svg";